/** CONFIG
 * Global parameters
 */
export class Config{
  demoTemplateId : string = "c37336d9-05ac-40cd-b36b-c541608cc353" //For demo dashboard (QVT ANACT)
  supportEmail : string = "support@id-tree.com"
  transactionalEmail : string = "no-reply@id-tree.com"
  welcomeTemplateId : string = "37c811d7-fe37-4bf7-bcd9-1a6530505dae" //Test project for welcome modal (Engagement)
}